import type { JamTaskClue } from '@/src/types/JamChallengeDetails';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, ColumnLayout, Container } from '@amzn/awsui-components-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ClueContainer from './Clues/ClueContainer';

interface GameTaskCluesProps {
  clues: JamTaskClue[];
  isFacilitator?: boolean;
  // Force every Unlock button disabled for the facilitator awaiting-lab preview
  disableUnlock?: boolean;
}

const GameTaskClues: React.FC<GameTaskCluesProps> = ({ clues, isFacilitator, disableUnlock }) => {
  const { t } = useTranslation();
  if (!clues?.length) {
    return null;
  }
  const latestClueUsed = clues.reduce((latest, clue) => {
    if (clue.used && clue.order > latest) {
      return clue.order;
    }
    return latest;
  }, 0);
  return (
    <Container>
      <ColumnLayout columns={1} borders="horizontal">
        <Box variant="h2">{t(i18nKeys.myJams.challenges.details.task.clue.clues)}</Box>
        {clues?.map((clue) => (
          <ClueContainer
            key={`${clue.title}-${clue.order}`}
            data-testid={`${clue.title}-${clue.order}`}
            title={clue.title ?? ''}
            penalty={clue.cluePenalty ?? 0}
            order={clue.order}
            description={clue.description}
            btnText={t(i18nKeys.myJams.challenges.details.task.clue.unlockClue)}
            used={clue.used}
            isFacilitator={!!isFacilitator}
            disableClueBtn={disableUnlock || clue.order > latestClueUsed + 1}
          />
        ))}
      </ColumnLayout>
    </Container>
  );
};

export default GameTaskClues;
